var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('stand-out-block',{staticClass:"translate-cta"},[_c('zupu-description-helper'),_c('mcr-button-router-link',{staticClass:"action-button",attrs:{"to":_vm.toRoute,"rel":"nofollow"}},[_vm._v("Explore Translation Options")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }